// Build a human-friendly download filename for a filing attachment.
//
// Legacy/system attachments are stored with an opaque blob-style name (a bare GUID, often with
// no extension), so trusting the stored name made the browser save e.g.
// "4f0a756e-1c2d-4e5f-8a9b-0c1d2e3f4a5b" — meaningless and unopenable. Derive a meaningful name
// from the obligation + period and always guarantee a .pdf extension; only keep the stored name
// when it already looks like a real uploaded filename.

const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function hasUsableExtension(name: string): boolean {
  const dot = name.lastIndexOf('.');
  return dot > 0 && dot >= name.length - 5 && dot < name.length - 1;
}

export function attachmentDownloadName(
  obligationDisplayName: string,
  periodLabel: string,
  storedName?: string | null,
): string {
  if (storedName) {
    const base = storedName.replace(/\.[a-z0-9]{2,4}$/i, '');
    if (hasUsableExtension(storedName) && !GUID_RE.test(base)) return storedName;
  }
  const friendly = `${obligationDisplayName} - ${periodLabel}`
    .replace(/[\\/:*?"<>|]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return `${friendly || 'attachment'}.pdf`;
}
